var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-flex',{staticClass:"display-2 font-weight-black",staticStyle:{"z-index":"1"}},[_vm._v("\n    "+_vm._s(_vm.project.name)+"\n  ")]),_c('div',{style:({
      'background-color': _vm.project.data.color,
      width: '80px',
      height: '22px',
      'margin-left': '-5px',
      'margin-top': '-19px'
    })}),_c('v-flex',{staticClass:"title font-weight-light project-description"},[_vm._v("\n    "+_vm._s(_vm.project.description)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }